import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BookingContactService } from './booking-contact.service';
import { NotificationService } from '../../../modules_v2/shared/services/notification.service';

export interface BookingContactSyncDialogData {
  contactUid: string;
  contactName: string;
}

@Component({
  selector: 'app-booking-contact-sync-dialog',
  templateUrl: './booking-contact-sync-dialog.component.html',
  styleUrls: ['./booking-contact-sync-dialog.component.css'],
  standalone: false
})
export class BookingContactSyncDialogComponent implements OnInit {
  loading = true;
  saving = false;
  loadError: string = null;

  form = new UntypedFormGroup({
    factuName:       new UntypedFormControl(''),
    factuEmail:      new UntypedFormControl(''),
    factuPhone:      new UntypedFormControl(''),
    bookitFirstName: new UntypedFormControl(''),
    bookitLastName:  new UntypedFormControl(''),
    bookitEmail:     new UntypedFormControl(''),
    bookitPhone:     new UntypedFormControl('')
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: BookingContactSyncDialogData,
    private dialogRef: MatDialogRef<BookingContactSyncDialogComponent, boolean>,
    private bookingContactService: BookingContactService,
    private notify: NotificationService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.loadError = null;
    this.bookingContactService.getSyncStatus(this.data.contactUid).subscribe({
      next: (status) => {
        this.form.patchValue({
          factuName:  status.factuProfile.companyName || '',
          factuEmail: status.factuProfile.email       || '',
          factuPhone: status.factuProfile.phone       || '',
          bookitFirstName: status.bookitProfile?.firstName || status.factuProfile.companyName || '',
          bookitLastName:  status.bookitProfile?.lastName  || '',
          bookitEmail:     status.bookitProfile?.email     || status.factuProfile.email || '',
          bookitPhone:     status.bookitProfile?.phone     || status.factuProfile.phone || ''
        });
        this.loading = false;
      },
      error: (err) => {
        this.loadError = this.errorMessage(err, 'Error cargando el estado de sincronización.');
        this.loading = false;
      }
    });
  }

  copyNameToBookit():   void { this.form.get('bookitFirstName').setValue(this.form.get('factuName').value); }
  copyEmailToBookit():  void { this.form.get('bookitEmail').setValue(this.form.get('factuEmail').value); }
  copyPhoneToBookit():  void { this.form.get('bookitPhone').setValue(this.form.get('factuPhone').value); }

  copyNameFromBookit(): void {
    const full = [this.form.get('bookitFirstName').value, this.form.get('bookitLastName').value].filter(Boolean).join(' ');
    this.form.get('factuName').setValue(full);
  }
  copyEmailFromBookit(): void { this.form.get('factuEmail').setValue(this.form.get('bookitEmail').value); }
  copyPhoneFromBookit(): void { this.form.get('factuPhone').setValue(this.form.get('bookitPhone').value); }

  save(): void {
    if (this.saving || this.loading || this.loadError) { return; }
    this.saving = true;
    this.dialogRef.disableClose = true;
    this.bookingContactService.sync(this.data.contactUid, {
      firstName:       this.form.get('bookitFirstName').value || undefined,
      lastName:        this.form.get('bookitLastName').value  || undefined,
      email:           this.form.get('bookitEmail').value     || undefined,
      phone:           this.form.get('bookitPhone').value     || undefined,
      factuCompanyName: this.form.get('factuName').value      || undefined,
      factuEmail:       this.form.get('factuEmail').value     || undefined,
      factuPhone:       this.form.get('factuPhone').value     || undefined
    }).subscribe({
      next: () => {
        this.saving = false;
        this.dialogRef.disableClose = false;
        this.notify.ok('Contacto sincronizado con Bookcit');
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.saving = false;
        this.dialogRef.disableClose = false;
        this.notify.error(this.errorMessage(err, 'Error al sincronizar. Inténtalo de nuevo.'));
      }
    });
  }

  cancel(): void {
    if (this.saving) { return; }
    this.dialogRef.close(false);
  }

  private errorMessage(err: any, fallback: string): string {
    const body = err && err.error;
    if (body && typeof body === 'object') { return body.message || body.detail || body.title || fallback; }
    if (typeof body === 'string' && body.trim()) { return body; }
    return fallback;
  }
}
